import appConfig from '@/app/config'

// The widget cannot render without an embed id, so the feature only counts as on
// when the tenant has both switched it on and configured an id.
export const isPassolutionEnabled = () => {
  const { active, embedId } = appConfig.features.passolution
  return active && !!embedId
}
